import { useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import NoneAnchor from 'components/NoneAnchor'
import { stripKeywordTag } from 'features/creative/creativeUtil'
import { SiteText } from 'features/shared/SiteUrlLink'
import { batch, useDispatch, useSelector } from 'react-redux'
import { Link, useParams } from 'react-router-dom'
import Icon from 'components/Icon'
import Button from 'components/form/Button'
import { showCreativePreview } from 'features/dashboard/operation/creativePreview/creativePreviewSlice'
import { isEmpty } from 'utils'
import {
  AssetCategories,
  CreativeTypes,
  DashboardInfoTypes,
} from 'features/Codes'
import { DASHBOARD_REFERRER } from 'features/ad/useDashboardReferrer'
import { fetchDashboardInfoCreative } from 'features/dashboard/info/dashboardInfoSlice'
import {
  addActives,
  dashboardTreeActions,
} from 'features/dashboard/tree/dashboardTreeSlice'

export const CreativeNameCell = ({
  row: {
    original: {
      creativeId,
      creativeLinkId,
      creativeType,
      deleted,
      name,
      title,
      description,
      bizChannelUrl,
      talkChannelName,
      talkChannelPermalink,
      talkChannelProposalPhrase,
      assets,
      parentDomainInfo: {
        campaign: { id: campaignId },
        adGroup: { id: adGroupId },
      },
    },
  },
}) => {
  const dispatch = useDispatch()
  const { accountId: adAccountId } = useParams()
  const {
    visible,
    type,
    id: infoCreativeLinkId,
  } = useSelector(state => state.dashboard.info)
  const [open, setOpen] = useState(false)
  const displayAsset = useMemo(
    () => creativeType === CreativeTypes.BASIC && !isEmpty(assets),
    [creativeType, assets]
  )
  return (
    <div
      className={classNames('td_tbl', { depth_on: open })}
      style={{ width: 'inherit' }}>
      <div className="ad_material">
        <strong className="ad_name">{name}</strong>
        <div className="box_detail">
          <strong className="ad_subject">
            {creativeType === CreativeTypes.BASIC
              ? stripKeywordTag(title)
              : talkChannelName}
          </strong>
          <div className="ad_link">
            <span className="txt_link">
              {creativeType === CreativeTypes.BASIC ? (
                <SiteText siteUrl={bizChannelUrl} />
              ) : (
                talkChannelPermalink
              )}
            </span>
          </div>
          <span className="ad_desc">
            {creativeType === CreativeTypes.BASIC
              ? stripKeywordTag(description)
              : talkChannelProposalPhrase}
          </span>
          <div className="ad_util">
            <div className="f_left">
              <div className="single_wrap">
                {deleted ? (
                  <Button line disabled>
                    편집하여 새로등록
                    <Icon name="edit" />
                  </Button>
                ) : (
                  <Link
                    to={`/${adAccountId}/ads/campaigns/${campaignId}/groups/${adGroupId}/creatives/save-as/${creativeId}?from=${DASHBOARD_REFERRER.CREATIVE}`}
                    className="btn_gm gm_line">
                    <span className="inner_g">
                      편집하여 새로등록
                      <Icon name="edit" />
                    </span>
                  </Link>
                )}
              </div>
              <div className="single_wrap">
                <Button
                  line
                  disabled={deleted}
                  onClick={() => dispatch(showCreativePreview(creativeId))}>
                  미리보기
                </Button>
              </div>
            </div>
            {displayAsset && (
              <NoneAnchor
                className={classNames('link_depthitem', { on: open })}
                onClick={() => setOpen(!open)}>
                <span className="ico_comm ico_depth" />
              </NoneAnchor>
            )}
          </div>
        </div>

        {!deleted && visible && (
          <div className="group_btn">
            <span
              className={classNames('link_chart', {
                on:
                  type === DashboardInfoTypes.CREATIVE &&
                  infoCreativeLinkId === creativeLinkId,
                show:
                  type === DashboardInfoTypes.CREATIVE &&
                  infoCreativeLinkId === creativeLinkId,
              })}>
              <NoneAnchor
                className="link_g"
                onClick={() => {
                  batch(() => {
                    dispatch(dashboardTreeActions.setAdgroupId(adGroupId))
                    dispatch(addActives(campaignId))
                    dispatch(
                      fetchDashboardInfoCreative({
                        id: creativeLinkId,
                        showError: true,
                      })
                    )
                  })
                }}>
                <span className="ico_comm ico_chart">소재 정보</span>
              </NoneAnchor>
            </span>
          </div>
        )}
      </div>
      {displayAsset && (
        <div className="detail_material">
          <div className="item_box">
            <span className="txt_type">
              이미지형{' '}
              <span className="fc_emph">
                {
                  assets.filter(
                    asset => asset.type.category === AssetCategories.IMAGE.name
                  ).length
                }
              </span>
            </span>
            {assets
              .filter(
                asset => asset.type.category === AssetCategories.IMAGE.name
              )
              .map(asset => asset.type.description)
              .join(', ')}
          </div>
          <div className="item_box">
            <span className="txt_type">
              텍스트형{' '}
              <span className="fc_emph">
                {
                  assets.filter(
                    asset => asset.type.category === AssetCategories.TEXT.name
                  ).length
                }
              </span>
            </span>
            {assets
              .filter(
                asset => asset.type.category === AssetCategories.TEXT.name
              )
              .map(asset => asset.type.description)
              .join(', ')}
          </div>
          <div className="item_box">
            <span className="txt_type">
              버튼형{' '}
              <span className="fc_emph">
                {
                  assets.filter(
                    asset => asset.type.category === AssetCategories.BUTTON.name
                  ).length
                }
              </span>
            </span>
            {assets
              .filter(
                asset => asset.type.category === AssetCategories.BUTTON.name
              )
              .map(asset => asset.type.description)
              .join(', ')}
          </div>
          <div className="item_box">
            <span className="txt_type">
              연동형{' '}
              <span className="fc_emph">
                {
                  assets.filter(
                    asset => asset.type.category === AssetCategories.LINK.name
                  ).length
                }
              </span>
            </span>
            {assets
              .filter(
                asset => asset.type.category === AssetCategories.LINK.name
              )
              .map(asset => asset.type.description)
              .join(', ')}
          </div>
        </div>
      )}
    </div>
  )
}
CreativeNameCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      creativeId: PropTypes.string,
      creativeLinkId: PropTypes.string,
      creativeType: PropTypes.oneOf([
        CreativeTypes.BASIC,
        CreativeTypes.TALK_CHANNEL,
      ]),
      deleted: PropTypes.bool,
      name: PropTypes.string,
      title: PropTypes.string,
      description: PropTypes.string,
      bizChannelUrl: PropTypes.shape({
        protocol: PropTypes.string,
        url: PropTypes.string,
      }),
      talkChannelName: PropTypes.string,
      talkChannelPermalink: PropTypes.string,
      talkChannelProposalPhrase: PropTypes.string,
      assets: PropTypes.array,
      parentDomainInfo: PropTypes.shape({
        campaign: PropTypes.shape({
          id: PropTypes.string,
        }),
        adGroup: PropTypes.shape({
          id: PropTypes.string,
        }),
      }),
    }),
  }),
}
